import { RouteObject } from 'react-router-dom';
import SettingAndPrivacyRoutes from '~myAccount/pages/SettingAndPrivacy/routes';
import PersonalInfoRoutes from '~myAccount/pages/PersonalInfo/routes';
import CompanyInfoRoutes from '~myAccount/pages/CompanyInfo/routes';
import UserCardsRoutes from '~myAccount/pages/UserCards/routes';
import UserSubscription from '~myAccount/pages/UserSubscription/routes';
import {
  DesktopRoutes as AccountDetailsDesktopRoutes,
  MobileRoutes as AccountDetailsMobileRoutes,
} from '~myAccount/pages/AccountDetails/routes';
import AccountInfo from '~myAccount/pages/AccountDetails';
import ManageContactRoutes from '~myAccount/pages/ManageContact/routes';
import Wallet from '~myAccount/pages/Wallet/routes';
import MyAccountMobileSidebar from '~myAccount/components/MobileSidebar';
import useBreakpoint from '~/hooks/useBreakpoint';

const sharedRoutes: RouteObject[] = [
  ...SettingAndPrivacyRoutes,
  ...PersonalInfoRoutes,
  ...CompanyInfoRoutes,
  ...ManageContactRoutes,
  ...UserCardsRoutes,
  ...UserSubscription,
  ...Wallet,
];

const MyAccountIndex = () => {
  const { mdScreen } = useBreakpoint();
  return mdScreen ? <MyAccountMobileSidebar /> : <AccountInfo />;
};

const accountDetailsDesktopRoutes = AccountDetailsDesktopRoutes.filter(
  (route) => !route.index,
);

export const myAccountRoutes: RouteObject[] = [
  { index: true, element: <MyAccountIndex /> },
  ...accountDetailsDesktopRoutes,
  ...AccountDetailsMobileRoutes,
  ...sharedRoutes,
];
